export function resolveApiUrl(mode, settings = {}) {
  if (mode === 'development') return (settings.development || 'http://localhost:5000').replace(/\/$/, '');
  const configured = settings.production || settings.legacy || '';
  // A development .env must never send production users to their own localhost.
  if (/^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?=[:/]|$)/i.test(configured)) return '';
  // The www and bare website share one backend. Keep requests on the page's
  // origin so a first visit does not depend on cross-origin cookies or CORS.
  const hostname = settings.hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
  try {
    const api = new URL(configured);
    const websiteHosts = ['happytimesmemes.com', 'www.happytimesmemes.com'];
    if (websiteHosts.includes(hostname) && websiteHosts.includes(api.hostname) && api.pathname === '/' && !api.port) return '';
  } catch { /* Relative API addresses already use the page origin. */ }
  return configured.replace(/\/$/, '');
}
export const API_URL = resolveApiUrl(process.env.NODE_ENV, {
  development: process.env.REACT_APP_DEV_API_URL,
  production: process.env.REACT_APP_PRODUCTION_API_URL,
  legacy: process.env.REACT_APP_API_URL,
});
